var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgService1Icon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dental-checkup 1",
    clipPath: "url(#clip0_17_187)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Dental",
    d: "M21.2448 15.9789C21.1657 17.7334 20.1825 19.2524 18.75 20.0811V25.75C18.75 28.5114 16.5114 30.75 13.75 30.75V25.75C13.75 24.3693 12.6307 23.25 11.25 23.25C9.86931 23.25 8.75 24.3693 8.75 25.75V30.75C5.98856 30.75 3.75 28.5114 3.75 25.75V20.081C1.92025 19.0226 0.823496 16.838 1.40762 14.4749C1.85012 12.6847 3.35956 11.2439 5.16418 10.8643C6.89818 10.4996 8.52156 11.0341 9.65481 12.0884C10.5383 12.9103 11.9617 12.9103 12.8452 12.0884C13.6858 11.3064 14.796 10.8104 16.0211 10.7552M8.75 18.25L11.25 15.75V12.7M23.25 5V12.5M19.5 8.75H27M23.25 16.25C27.3921 16.25 30.75 12.8921 30.75 8.75C30.75 4.60787 27.3921 1.25 23.25 1.25C19.1079 1.25 15.75 4.60787 15.75 8.75C15.75 12.8921 19.1079 16.25 23.25 16.25Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_187"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgService1Icon);
export default __webpack_public_path__ + "static/media/service-1-icon.c327f274e9680e842e40c54be5e381dc.svg";
export { ForwardRef as ReactComponent };